import firebase, { firebaseAdmin } from "./Firebase.service";
import firestoreService from "./FireStore.service";



const Users = firestoreService.collection("v2_users");

export const auth = firebase.auth();
export const admin_auth = firebaseAdmin.auth();


export const createUser = (user) => {

  return Users
         .doc(user.uid)
         .set({ uid: user.uid,
                userName: user.displayName, 
                email: user.email,
                createdAt: Date.now(),
                LastSignedIn: Date.now()
              }).then(() => {
                console.log('User has been created  ');
                return { 
                  uid: user.uid,
                  userName: user.displayName, 
                  email: user.email,
                };
              })
              .catch((error) => {
                console.log("Create User failed",error);
                return Promise.reject(error);
            })
  } 


export const updateUserLastSignedIn = (user) => {

  return Users.doc(user.uid)
    .set({ lastSignedIn: Date.now()}, { merge: true })
    .then((res) => {
      console.log('User last signIn has been updated  ', res);
      return user;
    })
    .catch((error) => {
      console.log("User last signIn update failed",error);
      return Promise.reject(error);
    })
} 

export const updateUserProfile = (user) => {

  return Users.doc(user.uid)
    .set({ ...user }, { merge: true })
    .then(() => {
      console.log('User profile has been updated  ', user);
      return user;
    })
    .catch((error) => {
      console.log("User profile update failed",error);
      return Promise.reject(error);
    })
} 

export const signUpNewUser = (email, password) => {
  return auth
          .createUserWithEmailAndPassword(email, password)
          .then((cred) => {
              return Users.doc(cred.user.uid).set(
                    { userName: cred.user.displayName, 
                      email: cred.user.email 
                    }
                  )
            })
            .catch((error) => {
                  console.log('error',error);
            });

  }
 

export const createNewUser = (user) => {
  return admin_auth.createUserWithEmailAndPassword(user.email, 'hometownkey')
    .then((cred) => {
        return Users.doc(cred.user.uid).set(
          { 
            ...user,
            uid: cred.user.uid
          }
        ).then(() => {
          console.log('createNewUser success', user);
          return user;
        }).catch(err => {
          console.log('createNewUser error',err)
          return Promise.reject(err);
        })
      })
      .catch((error) => {
        console.log('createNewUser error',error);
        return Promise.reject(error);
      });

}
 
export const logOut = () => {
  return auth
        .signOut().then(()=> {
            console.log('logged out')
        })
        .catch((error) => {
            console.log(error.message)
            Promise.reject(error);
        })
}

export const loginUserWithEmail = (email, password) => {
    
  return auth
        .signInWithEmailAndPassword(email, password)
        .then((user) => {
            console.log('Login success',user);
            return user;
        }).catch((error) => {
            console.log('Login failed',error);
            return error;
        })
}

export const getAllUsers = () => {

  return Users
        .get()
        .then((querySnapshot) => {
            const data = querySnapshot.docs.map(doc => doc.data());
            console.log('all users',data);
        return data;
        }).catch((error) => {
          Promise.reject(error);
        });
    
}
export const getUser = (uid) => {
  console.log('uid',uid);
  return Users
        .doc(uid)
        .get()
        .then(documentSnapshot => {      
            if (documentSnapshot.exists) {
              return documentSnapshot.data();
            }
        }).catch((error) => {
            Promise.reject(error);
        })
}
